import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FormControl, TextField, Button, Divider } from "@mui/material";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { lookUpValidation } from "../../app/Validations/CustomValidation";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));


interface Props {
    lookUpHandler: (values: any) => void;
    loading: boolean;
    isFormEmpty: boolean;
    message: string;
    isError: boolean;
}

const LookUpForm = ({ lookUpHandler, loading, isFormEmpty, message, isError }: Props) => {

    let history = useNavigate();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Item>
                    <Typography variant={!isFormEmpty ? 'body1' : 'body2'} sx={{ fontSize: 16 }} color={!isFormEmpty && !isError ? 'black' : 'red'}>
                        {message}
                    </Typography>
                    <Formik
                        initialValues={{ warrantyNumber: '', serialNumber: '' }}
                        validationSchema={lookUpValidation}
                        onSubmit={(values) =>
                            lookUpHandler(values)}
                    >
                        {({ values, handleChange, handleBlur, isSubmitting }) => (
                            <Form>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="warrantyNumber"
                                        name="warrantyNumber"
                                        placeholder="Warranty Number"
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.warrantyNumber}
                                        variant="outlined"
                                        disabled={loading}
                                    />
                                    <ErrorMessage
                                        className="error"
                                        name="warrantyNumber"
                                        component="div"
                                    />
                                </FormControl>
                                <Divider variant="middle">OR</Divider>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="serialNumber"
                                        name="serialNumber"
                                        placeholder="Serial Number"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.serialNumber}
                                        variant="outlined"
                                        disabled={loading}
                                    />
                                    <ErrorMessage name="serialNumber" component="div" />
                                </FormControl>
                                <Button disabled={loading} variant="contained" type="submit">
                                    {loading ? 'Looking...' : 'Look up'}
                                </Button>
                                <Button disabled={loading} variant="contained" type="submit" onClick={() => history('/')} sx={{ ml: 2 }}>
                                    close
                                </Button>

                            </Form>
                        )}
                    </Formik>

                </Item>
            </Grid>
        </Grid >
    )
}

export default LookUpForm